import { getCountries } from '../api/countries'

export const state = {
  countries: []
}

export const getters = {
  countries: (state) => {
    return state.countries
  }
}

export const mutations = {
  SET_COUNTRIES: (state, countries) => {
    state.countries = countries
  }
}

export const actions = {
  async GetCountries ({ commit, rootGetters }, options = {}) {
    if (state.countries.length > 0) {
      return
    }
    let { data } = await getCountries(rootGetters['general/contractor'])
    commit('SET_COUNTRIES', data)
  }
}
